import React from 'react'
import Typography from "@mui/material/Typography";
import { FaAnglesLeft, FaAnglesRight, FaAngleLeft, FaBuilding } from "react-icons/fa6";
import newTab from "../assets/new-tab.jpg";
import Map from "./Map";
import FSC from "../assets/FSC.jpg";
import ATFS from "../assets/ATFS.png";
import PEFC from "../assets/PEFC.jpg";
import SFI from "../assets/SFI.png";
import { IoCall } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { useLocation, useNavigate } from 'react-router-dom';


function Detail() {
    const navigate = useNavigate();
    const location = useLocation();
    const selectcompany = location.state?.data;
    console.log('dataaaaaaa',selectcompany);
    const handleclose =()=>{
        navigate(-1);
    }
  return (
    
      <>
          <div
            style={{
              marginLeft: "7em",
              marginTop: "0.5em",
              color: "#A5BF45",
            }}
            className="com-img"
          >
            <Typography 
            onClick={handleclose} 
            style={{ cursor: "pointer" }}>
              <FaAngleLeft />
              Back
            </Typography>
            <h4 style={{ margin: "1em 0em 0.2em 0em", fontWeight: "bold" }}>
              {selectcompany?.name}
            </h4>
          </div>
          <div>
            <div
              className="d-flex compny-con"
              style={{ width: "85%", margin: "auto" }}
            >
              <div style={{ width: "50%" }} className="com-info">
                <Typography>
                  <a
                    style={{ textDecoration: "none", color: "#707070" }}
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      `${selectcompany?.x},${selectcompany?.y}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {selectcompany?.complete_physical_address && (
                      <i
                        style={{ marginRight: "5px" }}
                        className="fa fa-map-marker-alt"
                      ></i>
                    )}
                    {selectcompany?.street_address}, {selectcompany?.city}, {selectcompany?.state}, {selectcompany?.zip}
                    {/* {selectcompany?.complete_physical_address} */}
                    {/* <br /> */}
                  </a>


                  {selectcompany?.company_contacts?.map((contact, index) => {
                    return (
                      <>
                        <a
                          href={`tel:${contact?.phone}`}
                          style={{
                            textDecoration: "none",
                            color: "#707070",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {contact?.phone && (
                            <i
                              style={{ marginRight: "5px" }}
                              className="fa fa-phone"
                            ></i>
                          )}
                          {contact?.phone}
                        </a>

                        <a
                          href={contact?.website}
                          style={{ textDecoration: "none", color: "#707070" }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {contact?.website && (
                            <img
                              src={newTab}
                              alt="newTab"
                              height={"17px"}
                              width={"17px"}
                            />
                          )}{" "}
                          {contact?.website}
                        </a>
                      </>
                    );
                  })}
                  <div className="d-flex flex-column" style={{ marginTop: '2em' }}>
                    <div
                      style={{ backgroundColor: "#A5BF45", color: "white" }}
                    >
                      <b style={{ margin: "1em" }}>Region/County</b>
                    </div>
                    <div className="col-12 d-flex flex-wrap">
                      {selectcompany?.region.map((data, index) => {
                        return (
                          <div
                            key={index}
                            className="equipment-item col-md-4"
                            style={{ width: "30.8%" }} // Adjusts each item to take up roughly 30% of the row
                          >
                            <Typography
                              style={{
                                marginLeft: "1em",
                                marginTop: "0.5em",
                              }}
                            >
                              {data}
                            </Typography>
                          </div>
                        )
                      })}



                    </div>
                  </div>

                  {/* <br></br>
                  <br></br> */}
                  {selectcompany?.migration_prep_tility}
                </Typography>
                <Typography style={{ marginBottom: "2em" }}>
                  <br></br>
                  {selectcompany?.products_produced?.length > 0 && (
                    <div className="d-flex flex-column">
                      <div
                        style={{ backgroundColor: "#A5BF45", color: "white" }}
                      >
                        <b style={{ margin: "1em" }}>Produces:</b>
                      </div>
                      <div className="col-12 d-flex flex-wrap">
                        {selectcompany?.products_produced.map((data, index) => {
                          return (
                            <div
                              key={index}
                              className="equipment-item col-md-4"
                              style={{ width: "30.8%" }} // Adjusts each item to take up roughly 30% of the row
                            >
                              <Typography
                                style={{
                                  marginLeft: "1em",
                                  marginTop: "0.5em",
                                }}
                              >
                                {data}
                              </Typography>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}{" "}
                  <br />
                  {selectcompany?.products_purchased?.length > 0 && (
                    <div className="d-flex flex-column">
                      <div
                        style={{ backgroundColor: "#A5BF45", color: "white" }}
                      >
                        <b style={{ margin: "1em" }}>Purchases:</b>
                      </div>
                      <div className="col-12 d-flex flex-wrap">
                        {selectcompany?.products_purchased.map(
                          (data, index) => {
                            return (
                              <div
                                key={index}
                                className="equipment-item col-md-4"
                                style={{ width: "30.8%" }} // Adjusts each item to take up roughly 30% of the row
                              >
                                <Typography
                                  style={{
                                    marginLeft: "1em",
                                    marginTop: "0.5em",
                                  }}
                                >
                                  {data}
                                </Typography>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  )}{" "}
                  <br />
                  {selectcompany?.species?.length > 0 && (
                    <div className="d-flex flex-column">
                      <div
                        style={{ backgroundColor: "#A5BF45", color: "white" }}
                      >
                        <b style={{ margin: "1em" }}>Species:</b>
                      </div>
                      <div className="col-12 d-flex flex-wrap">
                        {selectcompany?.species.map((data, index) => {
                          return (
                            <div
                              key={index}
                              className="equipment-item col-md-4"
                              style={{ width: "30.8%" }} // Adjusts each item to take up roughly 30% of the row
                            >
                              <Typography
                                style={{
                                  marginLeft: "1em",
                                  marginTop: "0.5em",
                                }}
                              >
                                {data}
                              </Typography>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}{" "}
                  <br />
                  {selectcompany?.equipments?.length > 0 && (
                    <div className="d-flex flex-column">
                      <div
                        style={{ backgroundColor: "#A5BF45", color: "white" }}
                      >
                        <b style={{ margin: "1em" }}>Equipment:</b>
                      </div>
                      <div className="col-12 d-flex flex-wrap">
                        {selectcompany?.equipments.map((data, index) => {
                          return (
                            <div
                              key={index}
                              className="equipment-item col-md-4"
                              style={{ width: "30.8%" }} // Adjusts each item to take up roughly 30% of the row
                            >
                              <Typography
                                style={{
                                  marginLeft: "1em",
                                  marginTop: "0.5em",
                                }}
                              >
                                {data}
                              </Typography>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}{" "}
                  <br />
                  {selectcompany?.residue?.length > 0 && (
                    <div className="d-flex flex-column">
                      <div
                        style={{ backgroundColor: "#A5BF45", color: "white" }}
                      >
                        <b style={{ margin: "1em" }}>Residue:</b>
                      </div>
                      <div className="col-12 d-flex flex-wrap">
                        {selectcompany?.residue.map((data, index) => {
                          return (
                            <div
                              key={index}
                              className="equipment-item col-md-4"
                              style={{ width: "30.8%" }} // Adjusts each item to take up roughly 30% of the row
                            >
                              <Typography
                                style={{
                                  marginLeft: "1em",
                                  marginTop: "0.5em",
                                }}
                              >
                                {data}
                              </Typography>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}{" "}
                  <br />
                  {selectcompany?.services?.length > 0 && (
                    <div className="d-flex flex-column">
                      <div
                        style={{ backgroundColor: "#A5BF45", color: "white" }}
                      >
                        <b style={{ margin: "1em" }}>Services:</b>
                      </div>
                      <div className="col-12 d-flex flex-wrap">
                        {selectcompany?.services.map((data, index) => {
                          return (
                            <div
                              key={index}
                              className="equipment-item col-md-4"
                              style={{ width: "30.8%" }} // Adjusts each item to take up roughly 30% of the row
                            >
                              <Typography
                                style={{
                                  marginLeft: "1em",
                                  marginTop: "0.5em",
                                }}
                              >
                                {data}
                              </Typography>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  <br />
                  <b>Log Buying Preferences</b>
                  <div style={{ marginLeft: "1em", marginTop: "0.5em" }}>
                    {selectcompany?.accept_bid_logs && (
                      <div>
                        {" "}
                        <Typography>
                          <b>Accepts Bid Logs: </b>
                          {selectcompany?.accept_bid_logs ? "Yes" : "No"}
                        </Typography>
                      </div>
                    )}
                    {selectcompany?.species_preference?.length > 0 && (
                      <div>
                        {" "}
                        <Typography>
                          <b> Species Preference:</b>{" "}
                          {selectcompany?.species_preference}
                        </Typography>
                      </div>
                    )}
                    {selectcompany?.min_diameter?.length > 0 && (
                      <div>
                        {" "}
                        <Typography>
                          <b> Minimum Diameter (in):</b>{" "}
                          {selectcompany?.min_diameter}
                        </Typography>
                      </div>
                    )}
                    {selectcompany?.max_diameter?.length > 0 && (
                      <div>
                        {" "}
                        <Typography>
                          <b>Maximum Diameter (in):</b> {selectcompany?.max_diameter}
                        </Typography>
                      </div>
                    )}
                    {selectcompany?.diameter_preference?.length > 0 && (
                      <div>
                        {" "}
                        <Typography>
                          <b>Diameter Preference (in):</b>{" "}
                          {selectcompany?.diameter_preference}
                        </Typography>
                      </div>
                    )}
                    {selectcompany?.min_length?.length > 0 && (
                      <div>
                        {" "}
                        <Typography>
                          <b>Minimum Length (ft):</b> {selectcompany?.min_length}
                        </Typography>
                      </div>
                    )}
                    {selectcompany?.max_length?.length > 0 && (
                      <div>
                        {" "}
                        <Typography>
                          <b>Maximum Length (ft):</b> {selectcompany?.max_length}
                        </Typography>
                      </div>
                    )}
                    {selectcompany?.length_preference?.length > 0 && (
                      <div>
                        {" "}
                        <Typography>
                          <b>Length Preference (ft):</b>{" "}
                          {selectcompany?.length_preference}
                        </Typography>
                      </div>
                    )}
                    {selectcompany?.annual_production?.length > 0 && (
                      <div>
                        {" "}
                        <Typography>
                          <b>Annual Production  (MBF):</b>{" "}
                          {selectcompany?.annual_production}
                        </Typography>
                      </div>
                    )}
                  </div>
                </Typography>
              </div>
              <div
                style={{ width: "35%", marginLeft: "4em" }}
                className="com-cer"
              >
                <div style={{ marginBottom: "1.5em" }}>
                  <Map
                    address={{
                      address: selectcompany?.address,
                      city: selectcompany?.city,
                      state: selectcompany?.state,
                      zip: selectcompany?.zip,
                    //   index: index,
                      lat: selectcompany?.x,
                      lng: selectcompany?.y,
                    }}
                    // dragable={dragable}
                    click={false}
                    // setCoords={setselectcompany}
                  />
                </div>

                <div>
                  <Typography>Certified By:</Typography>

                  {selectcompany?.certifications?.map((data, index) => {
                    let imgSrc = "";
                    if (data === "ATFS (American Tree Farm System)") {
                      imgSrc = ATFS;
                    } else if (data === "FSC (Forest Stewardship Council)") {
                      imgSrc = FSC;
                    } else if (
                      data ===
                      "PEFC (Programme for Endorsement of Forest Certification)"
                    ) {
                      imgSrc = PEFC;
                    } else if (
                      data === "SFI (Sustainable Forestry Initiative)"
                    ) {
                      imgSrc = SFI;
                    }

                    return (
                      <div
                        key={index}
                        className="d-flex"
                        style={{
                          width: "100%",
                          margin: "auto",
                          marginTop: "1em",
                          border: "1px solid gray",
                          borderRadius: "0.5em",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="d-flex"
                          style={{ alignItems: "center" }}
                        >
                          {imgSrc && (
                            <img
                              src={imgSrc}
                              alt={data}
                              style={{
                                margin: "0.5em",
                                height: "3em",
                                width: "3em",
                              }}
                            />
                          )}
                          <Typography
                            className="d-flex"
                            style={{ marginLeft: "1em", padding: "0.5em 0em" }}
                          >
                            {data}
                          </Typography>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div style={{ margin: "2em 0em" }}>
                  <Typography>Company Contacts: </Typography>
                  {selectcompany?.company_contacts?.map((data) => {
                    return (
                      <div
                        className="d-flex com-contact"
                        style={{
                          width: "100%",
                          margin: "auto",
                          marginTop: "1em",
                          border: "1px solid gray",
                          borderRadius: "0.5em",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ margin: "1em" }}>
                          <Typography>{data.name}</Typography>

                          <Typography>
                            <IoIosMail /> {data.email}
                          </Typography>
                          <Typography>
                            <IoCall /> {data.phone}
                          </Typography>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </>
  )
}

export default Detail
